function decodeTokenPayload(token) {
  try {
    const encodedPayload = token.split('.')[1];
    if (!encodedPayload) {
      return null;
    }

    const normalizedPayload = encodedPayload
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const paddedPayload = normalizedPayload.padEnd(
      normalizedPayload.length + ((4 - normalizedPayload.length % 4) % 4),
      '='
    );

    return JSON.parse(window.atob(paddedPayload));
  } catch (error) {
    return null;
  }
}

export function isSessionActive() {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }

  const payload = decodeTokenPayload(token);
  if (!payload || !payload.exp || payload.exp * 1000 <= Date.now()) {
    return false;
  }

  return true;
}
